import React from 'react';
import ReactDOM from 'react-dom/client';

import { Provider } from 'react-redux'
import store from "./Redux Store/store";

import './index.scss';

import App from './App';
import reportWebVitals from './reportWebVitals';

import { ThemeProvider, createTheme } from "@aws-amplify/ui-react";
import { Amplify } from 'aws-amplify';
import awsmobile from './amplifyconfiguration.json';
import "@aws-amplify/ui-react/styles.css";
import { studioTheme as amplifyStudioTheme } from "./ui-components";

Amplify.configure(awsmobile);

const updatedAmplifyStudioTheme = createTheme({
    // Extend the theme to update global colors and specific component styles
    name: "blawnode-theme-updates", 
    tokens: {
        colors: {
            font: {
                // Assuming label text should be white
                primary: { value: "#9badb7" },
                secondary: { value: "#fff" },
            },
        },
        components: {
            button: {
                focus: {
                    boxShadow: { value: "0 0 0 3px #45283c" },
                    color: { value: "#d77bba" },
                    borderColor: { value: "transparent" },
                },
                // Keep existing primary background
                primary: {
                    backgroundColor: { value: "#d77bba" },
                    color: { value: "#ffffff" },
                    borderColor: { value: "transparent" },
                    focus: {
                        backgroundColor: { value: "#76428a" },
                        borderColor: { value: "transparent" },
                        boxShadow: { value: "0 0 0 3px #45283c" },
                    },
                    hover: {
                        backgroundColor: { value: "#76428a" },
                        borderColor: { value: "transparent" },
                    },
                    pressed: {
                        backgroundColor: { value: "#d77bba" },
                        borderColor: { value: "transparent" },
                        color: { value: "#76428a" },
                    },
                    active: {
                        backgroundColor: { value: "#45283c" },
                        borderColor: { value: "transparent" },
                    },
                },
                // Default button (used by many generated forms like "Add item")
                backgroundColor: { value: "#45283c" },
                color: { value: "#76428a" },
                borderColor: { value: "transparent" },
                hover: {
                    backgroundColor: { value: "#76428a" },
                    color: { value: "#d77bba" },
                    borderColor: { value: "transparent" },
                },
                active: {
                    backgroundColor: { value: "#45283c" },
                    borderColor: { value: "transparent" },
                    color: { value: "#ffffff" },
                },
                pressed: {
                    backgroundColor: { value: "#d77bba" },
                    borderColor: { value: "transparent" },
                    color: { value: "#76428a" },
                },
                link: {
                    // Mirror primary submit button colors
                    backgroundColor: { value: "#d77bba" },
                    color: { value: "#ffffff" },
                    borderColor: { value: "transparent" },
                    focus: {
                        backgroundColor: { value: "#45283c" },
                        borderColor: { value: "transparent" },
                        boxShadow: { value: "0 0 0 3px #45283c" },
                        color: { value: "#ffffff" },
                    },
                    hover: {
                        backgroundColor: { value: "#76428a" },
                        borderColor: { value: "transparent" },
                        color: { value: "#ffffff" },
                    },
                    active: {
                        backgroundColor: { value: "#45283c" },
                        borderColor: { value: "transparent" },
                        color: { value: "#ffffff" },
                    },
                    pressed: {
                        backgroundColor: { value: "#d77bba" },
                        borderColor: { value: "transparent" },
                        color: { value: "#76428a" },
                    },
                },
            },
            switchfield: {
                track: {
                    backgroundColor: { value: "#45283c" },
                    borderColor: { value: "transparent" },
                    checked: {
                        backgroundColor: { value: "#d77bba" },
                        borderColor: { value: "transparent" },
                    },
                },
                thumb: {
                    backgroundColor: { value: "#ffffff" },
                    borderColor: { value: "transparent" },
                    checked: {
                        backgroundColor: { value: "#ffffff" },
                        borderColor: { value: "transparent" },
                    },
                },
            },
            field: {
                label: {
                    color: { value: "#9badb7" },
                },
            },
            fieldcontrol: {
                placeholder: {
                    color: { value: "#595652" },
                },
                // Input text color (affects Date field text)
                color: { value: "#ffffff" },
                backgroundColor: { value: "#45283c" },
                focus: {
                    borderColor: { value: "#d77bba" },
                    backgroundColor: { value: "#d77bba" },
                    boxShadow: { value: "0 0 0 3px #45283c" },
                },
                hovered: {
                    borderColor: { value: "#d77bba" },
                },
            },
            badge: {
                backgroundColor: { value: "#d77bba" },
                color: { value: "#fff" },
            },
            heading: {
                color: { value: "#fff" },
            },
            storagemanager: {
                previewer: {
                    backgroundColor: { value: "#222034" },
                },
                dropzone: {
                    backgroundColor: { value: "#222034" },
                },
            },
        },
    },
}, amplifyStudioTheme);

const updatedAmplifyStudioTheme2 = createTheme({
    // Extend the theme to update global colors and specific component styles
    name: "blawnode-theme-updates", 
    tokens: {
        colors: {
            primary: {
                10: { value: "#f3e8ff" },
                20: { value: "#e9d5ff" },
                40: { value: "#d8b4fe" },
                60: { value: "#76428A" },
                80: { value: "#a855f7" },
                90: { value: "#9333ea" },
                100: { value: "#5a1f6b" },
            },
            secondary: {
                10: { value: "#fdf2f8" },
                20: { value: "#fce7f3" },
                40: { value: "#fbcfe8" },
                60: { value: "#D77BBA" },
                80: { value: "#f472b6" },
                90: { value: "#ec4899" },
                100: { value: "#be185d" },
            },
            font: {
                // Assuming label text should be white
                primary: { value: "#fff" },
                secondary: { value: "#9badb7" },
            },
        },
        components: {
            button: {
                // Default button (used by many generated forms like "Add item")
                backgroundColor: { value: "#45283c" },
                color: { value: "#76428a" },
                borderColor: { value: "transparent" },
                hover: {
                    backgroundColor: { value: "#3a1f2e" },
                    color: { value: "#76428a" },
                    borderColor: { value: "transparent" },
                },
                active: {
                    backgroundColor: { value: "#2f1825" },
                    borderColor: { value: "transparent" },
                    color: { value: "#76428a" },
                },
                pressed: {
                    backgroundColor: { value: "#24121c" },
                    borderColor: { value: "transparent" },
                    color: { value: "#76428a" },
                },
                focus: {
                    backgroundColor: { value: "#3a1f2e" },
                    color: { value: "#76428a" },
                    borderColor: { value: "transparent" },
                },
            },
            badge: {
                backgroundColor: { value: "#d77bba" },
            },
            storagemanager: {
                previewer: {
                    backgroundColor: { value: "#222034" },
                },
                dropzone: {
                    backgroundColor: { value: "#222034" },
                },
            },
        },
    },
}, amplifyStudioTheme);



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <ThemeProvider theme={updatedAmplifyStudioTheme2}>
                <App />
            </ThemeProvider>
        </Provider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
